import React from 'react';
import TableC from '../basicElement/TableC';

function ImportantEventTable({ data }) {
    const filterDate = (text) => text ? text.slice(0, 10) : '';

    const handleStringLinefeed = (text) => {
        const arr = (text || '').split('；');
        const result = arr.map((item, index) => {
            return <span key={index}>{item}{index < arr.length - 1 ? ';' : ''}<br /></span>;
        });
        return result;
    }

    const getColumns = () => {
        const columns = [{
            title: '重大事件单号',
            dataIndex: 'majorEventNumber',
            key: 'majorEventNumber',
            fixed: 'left',
            width: 110,
        }, {
            title: '报告类型',
            dataIndex: 'reportTypeShow',
            key: 'reportTypeShow',
            fixed: 'left',
            width: 80,
        }, {
            title: '事件归属类型',
            dataIndex: 'eventType',
            key: 'eventType',
            width: 160,
            render: handleStringLinefeed,
        }, {
            title: '事件发生时间',
            dataIndex: 'eventHappenDate',
            key: 'eventHappenDate',
            width: 90,
            render: filterDate,
        }, {
            title: '事件获知时间',
            dataIndex: 'eventKnowDate',
            key: 'eventKnowDate',
            width: 90,
            render: filterDate,
        }, {
            title: '事件报告时间',
            dataIndex: 'eventReportDate',
            key: 'eventReportDate',
            width: 90,
            render: filterDate,
        }, {
            title: '报告人',
            dataIndex: 'reportUserName',
            key: 'reportUserName',
            width: 70,
        }, {
            title: '上报PM/LM时间',
            dataIndex: 'reportToPmLmDate',
            key: 'reportToPmLmDate',
            width: 110,
            render: filterDate,
        }, {
            title: '上报QA时间',
            dataIndex: 'reportToQaDate',
            key: 'reportToQaDate',
            width: 90,
            render: filterDate,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 120,
        }, {
            title: '项目名称',
            dataIndex: 'investigationSpecialName',
            key: 'investigationSpecialName',
            width: 160,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineTypeShow',
            key: 'investigationMedicineTypeShow',
            width: 100,
        }, {
            title: '给药方式',
            dataIndex: 'administrationModeName',
            key: 'administrationModeName',
            width: 100,
        }, {
            title: '申办方',
            dataIndex: 'sponsorName',
            key: 'sponsorName',
            width: 120,
        }, {
            title: 'CRO',
            dataIndex: 'croName',
            key: 'croName',
            width: 120,
        }, {
            title: '津石PM',
            dataIndex: 'pmNames',
            key: 'pmNames',
            width: 80,
        }, {
            title: '申办方PM',
            dataIndex: 'sponsorPm',
            key: 'sponsorPm',
            width: 80,
        }, {
            title: 'CRO PM',
            dataIndex: 'croPm',
            key: 'croPm',
            width: 80,
        }, {
            title: '涉及层面',
            dataIndex: 'influenceLevelShow',
            key: 'influenceLevelShow',
            width: 90,
        }, {
            title: '涉及研究中心',
            dataIndex: 'siteNames',
            key: 'siteNames',
            width: 110,
        }, {
            title: 'CRC',
            dataIndex: 'crcNameCodes',
            key: 'crcNameCodes',
            width: 120,
            render: handleStringLinefeed,
        }, {
            title: 'CRC直线主管',
            dataIndex: 'leaderNameCodes',
            key: 'leaderNameCodes',
            width: 120,
            render: handleStringLinefeed,
        }, {
            title: '重大事件发生类型',
            dataIndex: 'happenTypeShow',
            key: 'happenTypeShow',
            width: 240,
        }, {
            title: '重大事件风险等级',
            dataIndex: 'riskLevel',
            key: 'riskLevel',
            width: 80,
        }, {
            title: '重大事件可能造成的影响',
            dataIndex: 'possibleImpact',
            key: 'possibleImpact',
            width: 120,
            render: handleStringLinefeed,
        }, {
            title: '主要责任方',
            dataIndex: 'mainResponsible',
            key: 'mainResponsible',
            width: 80,
        }, {
            title: '与津石员工相关性',
            dataIndex: 'jsEmployeeRelevance',
            key: 'jsEmployeeRelevance',
            width: 80,
        }, {
            title: '项目或方案要求描述',
            dataIndex: 'projectSchemeDescription',
            key: 'projectSchemeDescription',
            width: 80,
        }, {
            title: '实际操作情况',
            dataIndex: 'actualOperation',
            key: 'actualOperation',
            width: 90,
        }, {
            title: '目前对受试者及研究中心的影响',
            dataIndex: 'impactToSubjectsSite',
            key: 'impactToSubjectsSite',
            width: 120,
        }, {
            title: '重大事件处理结束与否',
            dataIndex: 'majorDealIsEndShow',
            key: 'majorDealIsEndShow',
            width: 90,
        }, {
            title: '最终处理情况及影响',
            dataIndex: 'finalTreatmentImpact',
            key: 'finalTreatmentImpact',
            width: 130,
        }, {
            title: '备注',
            dataIndex: 'comments',
            key: 'comments',
            width: 160,
        }];
        return columns;
    };

    return (
        <div>
            <TableC
                data={data}
                scrollY={300}
                columns={getColumns()}
                rowKey="performanceMajorEventId"
                pagination={false}
                className="importantEvent"
            />
        </div>
    )
}

export default ImportantEventTable;


// WEBPACK FOOTER //
// ./src/components/home/ImportantEventTable.js